import React from 'react';
import '../../i18n';
import { withTranslation } from 'react-i18next';
import styles from './styles';
import { Button, withStyles } from '@material-ui/core';

const Welcome = ({ classes: { welcome_user, anchorButton }, user, onSignOut, t }) => {
  return (
    <div>
      <div className={welcome_user}> {t('welcome.toyota')}</div>
      {t('screens.home.Greeting')} <strong>{user.username}</strong>!
      <Button className={anchorButton} onClick={onSignOut}>
        Sign out
      </Button>
    </div>
  );
};

export default withStyles(styles)(withTranslation()(Welcome));
